import React from 'react';
import PropTypes from 'prop-types';

import ItemId from "src/core/gd-ui/id/item-id";

export default function CustomFieldId(props) {
    if (!props.customField || !props.customField.id) return false;

    return (
        <div className="details-item">
            <div className="label-details ui5-txt-not-important-tiny">System ID:</div>
            <div className="value ui5-txt-default flex-r fl-ac">
                <ItemId className="m-r-15" renderType="text" itemId={props.customField.id} itemName="System" copyId={true} copyUrl={false} />
            </div>
        </div>
    );
}

CustomFieldId.propTypes = {
    customField: PropTypes.object
}
